import AIResumeModal from './CreateResumeWithAI'
export default AIResumeModal
